import { render, staticRenderFns } from "./expect-bonus-detail.vue?vue&type=template&id=272acf34&"
import script from "./expect-bonus-detail.vue?vue&type=script&lang=js&"
export * from "./expect-bonus-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports